export default (state = {}, action) => {
  switch (action.type) {
    case  'SET_LAYOUT':
      return {...state, route: action.route, tab: {}, data: action.data}
    default:
      return state;
  }
}